<template>
  <div>
    <h1>Find card</h1>
    <v-text-field v-model="lastFour" @input="debounce" outline />
    <!-- <ui:fragment rendered="#{empty findCardBean.cardId}">empty</ui:fragment>
    <ui:fragment rendered="#{not empty findCardBean.cardId}">
      <ui:repeat var="cardId" value="#{findCardBean.cardId}">
        <div>
          <h:outputText value="#{cardId}" />
        </div>
      </ui:repeat>
    </ui:fragment>-->
  </div>
</template>

<script>
// import nbmlaw from "@/api/nbmlaw";
export default {
  name: "FindCard",
  metaInfo() {
    return {
      title: "Find card",
      titleTemplate: "%s - Payments - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  data() {
    return { lastFour: "", timerId: null };
  },
  methods: {
    debounce() {
      clearTimeout(this.timerId);
      this.timerId = setTimeout(() => {
        this.search();
      }, 750);
    },
    search() {
      //should probably not implement this it is stupid
      console.log("Ran");
    }
  }
};
</script>